@if (this.dataSource.data | async; as data) {
	@if (data.totalItemCount > 0) {
		<stages-card class="myMostFrequentlyUsedElements">
			<span stagesCardTitle class="h5" translate="dashboard.myMostFrequentlyUsedElements"></span>
			<article class="my-most-frequently-used-elements">
				<stages-responsive-data-view
					#dataView
					listStyles="list dense"
					[dataSource]="dataSource"
					[listItemTemplate]="listItemTemplate"
					[idFn]="MyMostFrequentlyUsedElementsComponent.getId"
					[disabledFn]="MyMostFrequentlyUsedElementsComponent.isDisabled"
					translateNone="empty"
				>
				</stages-responsive-data-view>
			</article>
			<ng-template #listItemTemplate let-element>
				<a class="label" [routerLink]="getLink(element)">
					<i class="ico" [ngClass]="getIconClasses(element)"></i>
					<div class="text center">
						<span class="h4">{{ element.name }}</span>
						<p>{{ element.type.name }}</p>
					</div>
				</a>
			</ng-template>
		</stages-card>
	}
}
